import { render } from "./Canvas.vue?vue&type=template&id=e77be3ee&scoped=true&ts=true"
import script from "./Canvas.vue?vue&type=script&lang=ts"
export * from "./Canvas.vue?vue&type=script&lang=ts"

import "./Canvas.vue?vue&type=style&index=0&id=e77be3ee&scoped=true&lang=scss"

import exportComponent from "/home/appstore/appstore/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e77be3ee"]])

export default __exports__